module.exports = __webpack_public_path__ + "img/roodie_logo_white.5adf8958.svg";